import {post} from '@/utils/request';
import {erpserver} from '@/utils/baseUrl';
// import{sse_url} from '@/utils/baseUrl';

//产线列表
export async function linelist(params) {
    return post(erpserver+'/scline/list', params, true)
}